<template>
  <vodal :show="show"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :closeButton="false"
         :width="600"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto', 'max-width': '96%'}"
         @hide="$emit('hide-dialog')"
         id="alertDialog-dialog">
    <p>{{ textLabel | translate }}</p>
    <hr>
    <div class="text-right" id="alertDialog-text-right">
      <button class="btn btn-sm btn-primary" @click="$emit('hide-dialog')" id="alertDialog-okButton">{{ 'dialog.OK' | translate }}</button>
    </div>
  </vodal>
</template>

<script>
import Vodal from 'vodal';

export default {
  name: 'AlertDialog',
  components: { Vodal },
  props: ['show', 'textLabel']
}
</script>

<style scoped>
  p {
    font-size: 1rem;
  }
  .btn {
    min-width: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/AlertDialog.vue